// extracted by mini-css-extract-plugin
export default {"vector":"MyDebateRoom_vector__JaWeE","block":"MyDebateRoom_block__G8quP","line":"MyDebateRoom_line__GjWHb","position":"MyDebateRoom_position__R8A-W"};